import { useApolloClient } from '@apollo/client/react';

/**
 * Hook to handle the unread notification count in the cache
 */
export const useUnreadNotificationCount = () => {
    const client = useApolloClient();

    /**
     * Update the unread notification count in the cache
     * @param count - The amount to add or subtract from the unread notification count (can be a negative number)
     * @param setCount - Whether to set the given count as the new count
     */
    const updateUnreadNotificationCount = (
        count: number,
        setCount?: boolean
    ) => {
        client.cache.modify({
            fields: {
                currentUser(existing: { __ref: string } | null) {
                    if (existing) {
                        // Get the User object that currentUser references
                        const userRef = existing.__ref;

                        if (userRef) {
                            // Update the User its unreadNotificationCount field
                            client.cache.modify({
                                id: userRef,
                                fields: {
                                    unreadNotificationCount(existingCount = 0) {
                                        if (setCount) {
                                            return count > 0 ? count : 0;
                                        }

                                        const newCount = existingCount + count;

                                        // Makes sure the count is never negative
                                        return newCount > 0 ? newCount : 0;
                                    },
                                },
                            });
                        }
                    }

                    return existing;
                },
            },
        });
    };

    return {
        updateUnreadNotificationCount,
    };
};
